export default {"src":"/_next/static/media/close-filter.e8101cbe.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};